import classes from './RectangleButtonSecond.module.css'

const SyndicRectangleButtonSnd = (props) => {
    return(
        <button
            className={classes.sRoundButton}
            type={props.type || "button"}
            onClick={props.onClick}
            >{props.children}
        </button>
    )
}

export default SyndicRectangleButtonSnd;